import store from '../store';
import OrderSuppliers from '../views/order_suppliers/Index.vue'
import {checkauth} from "../Helper";

export default [
    {
        path: '/order-suppliers',
        name: 'order_suppliers',
        component: OrderSuppliers,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    // console.log(response)
                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },


]
